export const NEW_LINE = '\n'
export const CODE_INDICATOR = '```'
